var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',_vm._l((_vm.sectionOrder),function(section){return _c(section,{key:("component-" + section),tag:"component",staticClass:"siteContent__section",attrs:{"id":section.substr(7)}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }